import { render, staticRenderFns } from "./PostbackBilling.vue?vue&type=template&id=879e5bc6&scoped=true&"
import script from "./PostbackBilling.vue?vue&type=script&lang=js&"
export * from "./PostbackBilling.vue?vue&type=script&lang=js&"
import style0 from "./PostbackBilling.vue?vue&type=style&index=0&id=879e5bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e5bc6",
  null
  
)

export default component.exports